<script setup lang="ts">
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <StandardCard :title="t('diplomacy.noAlliance.title')" bottom-padding="2">
    <p class="mb-4">{{ t('diplomacy.noAlliance.notMember') }}</p>
    <router-link to="/diplomacy/alliances" class="text-blue-500 hover:underline">
      {{ t('diplomacy.noAlliance.viewAlliances') }}
    </router-link>
  </StandardCard>
</template>
